import { render } from "./all-brokerages.vue?vue&type=template&id=869c9d20"
import script from "./all-brokerages.vue?vue&type=script&lang=js"
export * from "./all-brokerages.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__